import React, { useState, useRef } from 'react'
import PageLayout from '@layouts/PageLayout'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { Button, Input, Table } from 'antd'
import Fetch from '@components/CRUD/Fetch'

// import ListOperation from '@components/CRUD/ListOperation'

import { client } from '@utils/client'

const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const [keyword, setKeyword] = useState()

  const fetch = async ({ page, pageSize, keyword }) => {
    let result = await client
      .get('/wallet', {
        params: {
          page: page,
          limit: pageSize,
          keyword: keyword,
        },
      })
      .then((res) => res.data)

    return result
  }

  const columns = [
    {
      title: t('rewards.point.column.no'),
      dataIndex: 'no',
      key: 'no',
      width: 50,
    },
    {
      title: t('rewards.point.column.name'),
      //dataIndex: 'name',
      key: 'name',
      width: 150,
      render: function name(dataRow) {
        return (
          <a
            href={`/collector-coins/${dataRow.userId}/history`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {dataRow.user.profile.firstname}
          </a>
        )
      },
    },
    {
      title: t('rewards.point.column.lastname'),
      // dataIndex: 'lastname',
      key: 'lastname',
      width: 150,
      render: function lastname(dataRow) {
        return <div> {dataRow.user.profile.lastname} </div>
      },
    },
    {
      title: t('rewards.point.column.coin'),
      dataIndex: 'balance',
      key: 'balance',
      width: '70%',
    },
  ]

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const style = {
    btnAddData: { borderRadius: '5px', width: '165px', height: '40px' },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Fetch fetch={fetch} params={{ page, pageSize, keyword }} ref={fetchRef}>
        {({ data, total }) => (
          <>
            <PageLayout
              title={t('rewards.point.listScreen.title')}
              shownBack={false}
            >
              <div style={style.divSearch}>
                <SearchInput fetchData={(keyword) => setKeyword(keyword)} />
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: defaultPageSize,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>
    </>
  )
}
const SearchInput = ({ fetchData }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keyword}
        placeholder=""
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t('rewards.list.search')}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
}
export default List
